import React from "react";

function RootCause({ rootData }) {
  return (
    <div className="d-flex flex-row gap-2 text-break text-wrap">
      {rootData?.root_causes?.defaultRootCause?.map((item, index) => {
        return <span className="fw-bold" key={index}>{item?.title} | </span>;
      })}

      {rootData?.root_causes?.primaryRootCause?.map((item, index) => {
        const isLastItem =
          index === rootData?.root_causes?.primaryRootCause?.length - 1;
        return (
          <span className="fw-bold" key={index}>
            {item?.title}
            {!isLastItem && " | "}
          </span>
        );
      })}
    </div>
  );
}

export default RootCause;
